var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("color__display " + (_vm.isColorWhite(_vm.value.label) ? 'color__display--white' : '') + " " + (_vm.inline ? 'color__display--inline' : '')),style:({ backgroundColor: _vm.value.label })})}
var staticRenderFns = []

export { render, staticRenderFns }